<template>
    <div class="product-qrcode">
        <canvas id="prodInfoQrcode" width="180" height="180"></canvas>
        <p>中国工品码</p>
    </div>
</template>

<script>
import UQRCode from 'uqrcodejs';
import {WinForm} from '@digital-supply-chain/module'
import {CompService,ProductService} from '@/service'

export default {
    props: {
        mdCode: { default: '' },
        compLogo: { default: '' },
        lectoParams: { default: { LectotypeParams: [] } },
        productDetail: { default: {} },
    },
    data() {
        this.qr = null;
        return {

        }
    },
    watch: {
        "lectoParams.SkuName": function(value) {
            this.createQrCode();
        }
    },
    mounted() {
        this.createQrCode();
    },
    methods: {
        createQrCode() {
            if (this.qr) {
                this.qr.canvasContext.clearRect(0, 0, 180, 180);
            }
            this.qr = new UQRCode();
            let Md5 = '';
            if (this.lectoParams.SkuName) {
                const dataObj = {
                    ProdName: this.productDetail.ProdName,
                    ProdLogo: this.productDetail.ProdLogo,
                    CompName: this.productDetail.CompName,
                    Code: this.mdCode,
                    LectoParams: this.lectoParams.LectotypeParams.filter(item => item.Value).map(item => ({
                        Name: item.Name,
                        Value: item.Value,
                    })),
                };
                Md5 = WinForm.md.getMD5Hash(JSON.stringify(dataObj));
                ProductService.setProdParams(Md5, dataObj);
            }
            this.qr.data = `https://big-engineer.global-dsc.cn/product-detail?code=${this.mdCode}&key=${Md5}`;
            this.qr.size = 180;
            const option = {
                margin: 3,
            };

            this.qr.setOptions(option);
			this.qr.make();
            const canvas = document.getElementById("prodInfoQrcode");
            const canvasContext = canvas.getContext("2d");
            this.qr.canvasContext = canvasContext;
            const ctx = this.qr.canvasContext;
            this.qr.drawCanvas();

            if (this.compLogo) {
                const image = new Image();
                image.src = CompService.getCompLogo(this.compLogo);
                image.onload = function () {
                    ctx.drawImage(this, 70, 74, 40, 32)
                }
            }
        },
    },
}
</script>

<style scoped lang="less">
.product-qrcode{
    width: 180px;
    float: left;
    margin-left: 16px;
    padding-top: 35px;
    p{
        font-size: 16px;
        margin: 0;
        padding: 0;
        line-height: 28px;
        text-align: center;
    }
}
</style>
